import { getUrlApi } from "../utilities/util";
import ApiHandler from "./ApiHandlers/ApiHandler";

export const baseURL = String(getUrlApi());

export type UpdateUserPayload = {
  Id: string;
  Name: string;
  Username: string;
  Email: string;
  Phone: string;
  Department?: string | null;
  Position?: string | null;
  GroupId: string;
  Active: boolean;
  Password?: string;
  ConfirmPassword?: string;
};

export type ListUsersParams = {
  pageNumber?: number;
  pageSize?: number;
  name?: string;
  username?: string;
  email?: string;
  department?: string;
  position?: string;
  phone?: string;
  createDate?: string;
  lastActivityDate?: string;
  sortField?: string;
  sortDirection?: "asc" | "desc";
  groupIds?: string[];
  active?: boolean | null;
};

export default class UserApi {
  static async GetById(userId: string): Promise<any> {
    const encodedId = encodeURIComponent(userId);
    return ApiHandler(baseURL).get(`/security/user/${encodedId}`);
  }

  static async Update(userId: string, payload: UpdateUserPayload): Promise<any> {
    const encodedId = encodeURIComponent(userId);
    return ApiHandler(baseURL).put(`/security/user/${encodedId}`, payload);
  }

  static async GetByFilterAsync(params: ListUsersParams = {}): Promise<any> {
    const {
      pageNumber = 1,
      pageSize = 12,
      name,
      username,
      email,
      department,
      position,
      phone,
      createDate,
      lastActivityDate,
      sortField,
      sortDirection,
      groupIds,
      active,
    } = params;

    const query = new URLSearchParams();
    query.append("pageNumber", String(pageNumber));
    query.append("pageSize", String(pageSize));

    const safeAppend = (key: string, value?: string): void => {
      const trimmed = value?.trim();
      if (trimmed) {
        query.append(key, trimmed);
      }
    };

    safeAppend("Name", name);
    safeAppend("Username", username);
    safeAppend("Email", email);
    safeAppend("Department", department);
    safeAppend("Position", position);
    safeAppend("Phone", phone);

    safeAppend("SortField", sortField);
    safeAppend("SortDirection", sortDirection);

    safeAppend("CreateDate", createDate);
    safeAppend("LastActivityDate", lastActivityDate);

    if (Array.isArray(groupIds)) {
      groupIds
        .filter((groupId) => typeof groupId === "string" && groupId.trim().length > 0)
        .forEach((groupId) => {
          query.append("GroupIds", groupId.trim());
        });
    }

    if (typeof active === "boolean") {
      query.append("Active", String(active));
    }

    const queryString = query.toString();
    const url = queryString.length > 0
      ? `/security/users/filter?${queryString}`
      : "/security/users/filter";

    return ApiHandler(baseURL).get(url);
  }

  static async Delete(userId: string): Promise<any> {
    const encodedId = encodeURIComponent(userId);
    return ApiHandler(baseURL).delete(`/security/user/${encodedId}`);
  }
}
